/* eslint-disable n/no-callback-literal */
const emailDomains = [
  '@gmail.com',
  '@outlook.com',
  '@yahoo.com',
  '@hotmail.com',
  '@msn.com',
  '@live.com',
  '@icloud.com'
]

/**
 * 获取邮箱域名补全
 * @param queryString
 * @param cb
 */
export const emailSuggestions = (queryString: string, cb: any) => {
  if (!queryString) {
    cb([])
  } else if (!queryString.includes('@')) {
    cb(emailDomains.map(r => ({
      value: queryString + r
    })))
  } else {
    const arr = queryString.split('@')
    const name = arr[0]
    const domain = '@' + arr[1]
    if (emailDomains.includes(domain)) {
      cb([])
    } else {
      const validDomains = emailDomains.filter(r => r.startsWith(domain))
      cb(validDomains.map(r => ({
        value: name + r
      })))
    }
  }
}
